import { useTranslation } from 'react-i18n-lite'

import {
  DocumentListCard,
  formatDateTime,
  Input
} from '@yes.technology/react-toolkit'

import { updateStatus } from 'status/shared'
import { StatusAction } from 'status/shared/situation.type'

import { useFetchYesObjects } from 'yesObject/shared'

import TaskActions from './TaskActions'

import {
  Container,
  Content,
  Description,
  FieldsRow,
  PriorityBadge,
  StyledField,
  UserAvatar,
  UserBlock,
  UserBlocks
} from './TaskObjectCard.styles'

import useKanbanContext from 'site/Renderer/components/Kanban/components/KanbanAutoColumns/useKanbanContext'
import { TaskObjectCardProps } from './TaskObjectCard.types'

type AllowedLocales = 'pt-BR' | 'en-US' | 'de-DE' | 'es-419'

const TaskField = ({ label, value }: { value: string; label?: string }) => (
  <StyledField>
    <Input informational required heightClass='small' {...{ label, value }} />
  </StyledField>
)

const DEFAULT_AVATAR_BASE64 =
  'data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiA/PjwhRE9DVFlQRSBzdmcgIFBVQkxJQyAnLS8vVzNDLy9EVEQgU1ZHIDEuMS8vRU4nICAnaHR0cDovL3d3dy53My5vcmcvR3JhcGhpY3MvU1ZHLzEuMS9EVEQvc3ZnMTEuZHRkJz48c3ZnIGVuYWJsZS1iYWNrZ3JvdW5kPSJuZXcgLTI3IDI0IDEwMCAxMDAiIGhlaWdodD0iMTAwcHgiIGlkPSJ1bmtub3duIiB2ZXJzaW9uPSIxLjEiIHZpZXdCb3g9Ii0yNyAyNCAxMDAgMTAwIiB3aWR0aD0iMTAwcHgiIHhtbDpzcGFjZT0icHJlc2VydmUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIgeG1sbnM6c2tldGNoPSJodHRwOi8vd3d3LmJvaGVtaWFuY29kaW5nLmNvbS9za2V0Y2gvbnMiIHhtbG5zOnhsaW5rPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5L3hsaW5rIj48Zz48Zz48ZGVmcz48Y2lyY2xlIGN4PSIyMyIgY3k9Ijc0IiBpZD0iY2lyY2xlIiByPSI1MCIvPjwvZGVmcz48dXNlIGZpbGw9IiNGNUVFRTUiIG92ZXJmbG93PSJ2aXNpYmxlIiB4bGluazpocmVmPSIjY2lyY2xlIi8+PGNsaXBQYXRoIGlkPSJjaXJjbGVfMV8iPjx1c2Ugb3ZlcmZsb3c9InZpc2libGUiIHhsaW5rOmhyZWY9IiNjaXJjbGUiLz48L2NsaXBQYXRoPjxnIGNsaXAtcGF0aD0idXJsKCNjaXJjbGVfMV8pIj48ZGVmcz48cGF0aCBkPSJNMzYsOTUuOWMwLDQsNC43LDUuMiw3LjEsNS44YzcuNiwyLDIyLjgsNS45LDIyLjgsNS45YzMuMiwxLjEsNS43LDMuNSw3LjEsNi42djkuOEgtMjd2LTkuOCAgICAgICBjMS4zLTMuMSwzLjktNS41LDcuMS02LjZjMCwwLDE1LjItMy45LDIyLjgtNS45YzIuNC0wLjYsNy4xLTEuOCw3LjEtNS44YzAtNCwwLTEwLjksMC0xMC45aDI2QzM2LDg1LDM2LDkxLjksMzYsOTUuOXoiIGlkPSJzaG91bGRlcnMiLz48L2RlZnM+PHVzZSBmaWxsPSIjRTZDMTlDIiBvdmVyZmxvdz0idmlzaWJsZSIgeGxpbms6aHJlZj0iI3Nob3VsZGVycyIvPjxjbGlwUGF0aCBpZD0ic2hvdWxkZXJzXzFfIj48dXNlIG92ZXJmbG93PSJ2aXNpYmxlIiB4bGluazpocmVmPSIjc2hvdWxkZXJzIi8+PC9jbGlwUGF0aD48cGF0aCBjbGlwLXBhdGg9InVybCgjc2hvdWxkZXJzXzFfKSIgZD0iTTIzLjIsMzVjMC4xLDAsMC4xLDAsMC4yLDBjMCwwLDAsMCwwLDAgICAgICBjMy4zLDAsOC4yLDAuMiwxMS40LDJjMy4zLDEuOSw3LjMsNS42LDguNSwxMi4xYzIuNCwxMy43LTIuMSwzNS40LTYuMyw0Mi40Yy00LDYuNy05LjgsOS4yLTEzLjUsOS40YzAsMC0wLjEsMC0wLjEsMCAgICAgIGMtMC4xLDAtMC4xLDAtMC4yLDBjLTAuMSwwLTAuMSwwLTAuMiwwYzAsMC0wLjEsMC0wLjEsMGMtMy43LTAuMi05LjUtMi43LTEzLjUtOS40Yy00LjItNy04LjctMjguNy02LjMtNDIuNCAgICAgIGMxLjItNi41LDUuMi0xMC4yLDguNS0xMi4xYzMuMi0xLjgsOC4xLTIsMTEuNC0yYzAsMCwwLDAsMCwwQzIzLjEsMzUsMjMuMSwzNSwyMy4yLDM1TDIzLjIsMzV6IiBmaWxsPSIjRDRCMDhDIiBpZD0iaGVhZC1zaGFkb3ciLz48L2c+PC9nPjxwYXRoIGQ9Ik0yMi42LDQwYzE5LjEsMCwyMC43LDEzLjgsMjAuOCwxNS4xYzEuMSwxMS45LTMsMjguMS02LjgsMzMuN2MtNCw1LjktOS44LDguMS0xMy41LDguMyAgICBjLTAuMiwwLTAuMiwwLTAuMywwYy0wLjEsMC0wLjEsMC0wLjIsMEMxOC44LDk2LjgsMTMsOTQuNiw5LDg4LjdjLTMuOC01LjYtNy45LTIxLjgtNi44LTMzLjhDMi4zLDUzLjcsMy41LDQwLDIyLjYsNDB6IiBmaWxsPSIjRjJDRUE1IiBpZD0iaGVhZCIvPjwvZz48L3N2Zz4='

export default function TaskObjectCard({
  priority = 'normal',
  des,
  sid,
  complement,
  executor,
  date_start_row: startDate,
  date_creation_row: submissionDate,
  uuid_status: statusUuid,
  version,
  uuid,
  uuid_Objectclass
}: TaskObjectCardProps) {
  const { t, language } = useTranslation()
  const [firstExecutor] = executor || []

  const { yesObjects: statusActions } = useFetchYesObjects<StatusAction>({
    filterBody: {
      query: { $and: [{ 'allowed_origin_status.code': { $eq: statusUuid } }] },
      objectclass: window.uuidObjectClassStatusAction
    }
  })
  const { onStatusChange, statusActionClassification } = useKanbanContext()

  const classification = statusActionClassification?.find(
    (classification) => classification.UUID_OBJECT === statusUuid
  )

  const changeStatus = (destinationStatusCode: string) => {
    updateStatus({
      objectVersion: version,
      objectUuid: uuid,
      objectclassUuid: uuid_Objectclass,
      destinationStatusCode,
      showLoading: false
    })

    onStatusChange?.(uuid, destinationStatusCode)
  }

  return (
    <Container>
      <DocumentListCard>
        <Content>
          <PriorityBadge priority={priority}>
            {t(`task.priority.${priority}`)}
          </PriorityBadge>
          <FieldsRow>
            <TaskField label={t('task.model')} value={des} />
            <TaskField label={t('task.sid')} value={sid ?? ''} />
          </FieldsRow>
          <h2>{des}</h2>
          <Description>{complement}</Description>
          <hr />
          <UserBlocks>
            <UserBlock>
              <div>{t('task.assigned-requester')}</div>
              <UserAvatar>
                <img
                  width={32}
                  height={32}
                  src={DEFAULT_AVATAR_BASE64}
                  alt=''
                />
                {'-'}
              </UserAvatar>
            </UserBlock>
            <UserBlock>
              <div>{t('task.assigned-executor')}</div>
              <UserAvatar>
                <img
                  width={32}
                  height={32}
                  src={DEFAULT_AVATAR_BASE64}
                  alt=''
                />
                {firstExecutor?.des || '-'}
              </UserAvatar>
            </UserBlock>
          </UserBlocks>
          <hr />
          <FieldsRow>
            <TaskField
              label={t('task.scheduled-submission')}
              value={formatDateTime(
                new Date(submissionDate),
                language as AllowedLocales,
                'date-time'
              )}
            />
            <TaskField
              label={t('task.scheduled-start')}
              value={formatDateTime(
                new Date(startDate),
                language as AllowedLocales,
                'date-time'
              )}
            />
          </FieldsRow>
          <TaskActions
            {...{
              statusActions,
              changeStatus,
              statusUuid,
              taskUuid: uuid,
              primaryStatusActionUuid:
                classification?.CHILDREN?.[0]?.UUID_OBJECT
            }}
          />
        </Content>
      </DocumentListCard>
    </Container>
  )
}
